export class ElementInserter {
    constructor(text, targetSelector, newElementClass) {
        this.text = text;
        this.target = targetSelector;
        this.newElementClass = newElementClass;
    }

    addDivBeforeElement() {
        const targetElement = document.querySelector(this.target);

        if (targetElement) {
            const newDiv = document.createElement('div');
            newDiv.textContent = this.text;
            newDiv.className = this.newElementClass;
            targetElement.parentNode.insertBefore(newDiv, targetElement);
        } else {
            console.debug(`Элемент с селектором ${this.target} не найден.`);
        }
    }

    setParentRelative() {
        const targetElement = document.querySelector(this.target);
        if (targetElement) {
            const parent = targetElement.parentNode;
            if (parent) {
                parent.style.position = 'relative';
            }
        } else {
            console.debug(`Элемент с селектором ${this.target} не найден для установки позиции relative.`);
        }

        return this
    }
}